export function isVersionedTransaction(transaction) {
    return 'version' in transaction;
}
